import { baseFetchToken, baseFetchTokenFullResponse } from './BaseSaga'
import SchedulerActions from '../Redux/SchedulerRedux'
import { getToken } from '../Services/GetToken'

export function * getScheduler (api, action) {
  yield baseFetchTokenFullResponse(
    api.getScheduler,
    action.data,
    getToken,
    SchedulerActions.getSchedulerSuccess,
    SchedulerActions.getSchedulerFailure
  )
}

export function * getSchedulerDetail (api, action) {
  yield baseFetchToken(
    api.getSchedulerDetail,
    action.data,
    getToken,
    SchedulerActions.getSchedulerDetailSuccess,
    SchedulerActions.getSchedulerDetailFailure
  )
}

export function * postScheduler (api, action) {
  yield baseFetchToken(
    api.postScheduler,
    action.data,
    getToken,
    SchedulerActions.postSchedulerSuccess,
    SchedulerActions.postSchedulerFailure
  )
}

export function * putScheduler (api, action) {
  yield baseFetchToken(
    api.putScheduler,
    action.data,
    getToken,
    SchedulerActions.putSchedulerSuccess,
    SchedulerActions.putSchedulerFailure
  )
}

export function * deleteScheduler (api, action) {
  yield baseFetchToken(
    api.deleteScheduler,
    action.data,
    getToken,
    SchedulerActions.deleteSchedulerSuccess,
    SchedulerActions.deleteSchedulerFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/SchedulerSagas.js